export const somethingWrong = 'Something went wrong';
export const requiredField = 'Required Field';
export const minLength = 'Minimum length is 8 characters';
export const maxLengthReached = 'Max. length reached';
export const notValidNumber = 'Not a valid number';
export const notValidEmail = 'Not a valid email'